export class PortfolioIndexMetadata {
  public identifier: string;
  public name: string;
}
